import {
  SET_LEVEL_ACTION,
  SET_TIPO_ACTION,
  SET_DATA_FINAL_ACTION,
  SET_DATA_INICIAL_ACTION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  RESET_PAGINATION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from './actions.type';
import {
  SET_TIPO,
  SET_LEVEL,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_CURRENT_PAGE,
  SET_OFFSET,
  SET_FILTER,
  SET_LIST_OPTIONS,
  SET_CURRENT_SESSION_STATE,
  INIT_STATE,
} from './mutations.type';

export default {
  [SET_TIPO_ACTION](context, tipo) {
    context.commit(SET_TIPO, tipo);
  },
  [SET_LEVEL_ACTION](context, level) {
    context.commit(SET_LEVEL, level);
  },
  [SET_DATA_FINAL_ACTION](context, dataFinal) {
    context.commit(SET_DATA_FINAL, dataFinal);
  },
  [SET_DATA_INICIAL_ACTION](context, dataInicial) {
    context.commit(SET_DATA_INICIAL, dataInicial);
  },
  [RESET_PAGINATION](context) {
    context.commit(SET_CURRENT_PAGE, 1);
    context.commit(SET_OFFSET, 0);
  },
  [SET_FILTER_ACTION](context, filter) {
    context.commit(SET_FILTER, filter);
    context.commit(SET_CURRENT_SESSION_STATE);
  },
  [SET_LIST_OPTIONS_ACTION](context, listOptions) {
    context.commit(SET_LIST_OPTIONS, listOptions);
    context.commit(SET_CURRENT_SESSION_STATE);
  },
  [SET_CURRENT_SESSION_STATE_ACTION](context, ids) {
    context.commit(SET_CURRENT_SESSION_STATE, ids);
  },
  [INIT_STATE_ACTION](context, ids) {
    context.commit(INIT_STATE, ids);
  },
};
